import type { z } from 'zod';

import type { LegacyExamAttemptSchema } from './schemas';

type LegacyExamAttemptField = keyof z.infer<typeof LegacyExamAttemptSchema>;

const listAttributes = [
  'id',
  'studentId',
  'subject',
  'examCode',
  'attemptNumber',
  'examId',
  'markerId',
  'markedDatetime',
  'creationDatetime',
  'dueDatetime',
  'outcome',
  'mark',
  'maxMark',
  'studentDetails',
  'markerDetails',
  'examLabel',
  'type',
  'unmarkedExamFileName',
  'markerComment',
] as const satisfies readonly LegacyExamAttemptField[];

const getAttributes = [...listAttributes] as const satisfies readonly LegacyExamAttemptField[];

const payrollAttributes = [
  'id',
  'studentId',
  'subject',
  'examCode',
  'attemptNumber',
  'examId',
  'markerId',
  'markedDatetime',
  'creationDatetime',
  'studentDetails',
  'examLabel',
  'type',
] as const satisfies readonly LegacyExamAttemptField[];

const updateAttributes = [
  'creationDatetime',
  'mark',
  'maxMark',
  'outcome',
  'examLabel',
  'markerId',
  'markerDetails',
  'type',
  'studentId',
  'studentDetails',
  'status',
  'markerComment',
] as const satisfies readonly LegacyExamAttemptField[];

// Each selected student costs two index queries on the exam analytics endpoint,
// so the picker is bounded rather than letting a whole cohort be requested at once
export const MAX_ANALYTICS_STUDENTS = 20;

export const LegacyExamAttemptAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Payroll: payrollAttributes,
  Update: updateAttributes,
};
